import { render, staticRenderFns } from "./CommentLine.vue?vue&type=template&id=4e4b4e54"
import script from "./CommentLine.vue?vue&type=script&lang=js"
export * from "./CommentLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports